export { default } from '@relo/sports-components/es/Tooltip';
export * from '@relo/sports-components/es/Tooltip';
